module.exports = __webpack_public_path__ + "img/title4.dee1d3bd.png";